// extracted by mini-css-extract-plugin
export default {"container":"sign-in-page_container__OEyWk","form":"sign-in-page_form__DYcIP"};